import { render, staticRenderFns } from "./PopupCreateReceiptDocument.vue?vue&type=template&id=2bac22b8"
import script from "./PopupCreateReceiptDocument.vue?vue&type=script&lang=js"
export * from "./PopupCreateReceiptDocument.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports